<template>
  <CContainer class="pt-5" fluid>
    <Loading :active.sync="isLoading"></Loading>
    <CRow>
      <CCol class="col-7">
        <h3 class="pl-3 mb-0 pb-0">Tracker</h3>
        <b-breadcrumb class="my-0 pt-1" style="border-bottom: 0px">
          <b-breadcrumb-item active>
            <CIcon name="cil-location-pin" />
            Vehicles > Tracker
          </b-breadcrumb-item>
        </b-breadcrumb>
      </CCol>
    </CRow>
    <CCard class="custom-card">
      <CCardBody class="p-3">
        <CRow>
          <CCol col="6">
            <b-form-group
              invalid-feedback="This input is required."
              label="From"
              label-for="report-periodFrom"
              :state="report.periodFrom.isValid"
            >
              <b-input-group>
                <b-form-datepicker
                  v-model="report.periodFrom.value" 
                  :max="report.periodFrom.maxValue"
                  :disabled="report.periodFrom.isDisabled"
                  id="report-periodFrom"
                  placeholder="DD/MM/YYYY"
                  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                  locale="id"
                  :state="report.periodFrom.isValid"
                ></b-form-datepicker>
                <b-form-timepicker
                  v-model="report.periodFrom.timeValue"
                  now-button
                  locale="id"
                ></b-form-timepicker>
              </b-input-group>
            </b-form-group>
          </CCol>
          <CCol col="6">
            <b-form-group
              invalid-feedback="This input is required."
              label="To"
              label-for="report-periodTo"
              :state="report.periodTo.isValid"
            >
              <b-input-group>
                <b-form-datepicker
                  v-model="report.periodTo.value" 
                  :max="report.periodTo.maxValue"
                  :disabled="report.periodTo.isDisabled"
                  id="report-periodTo"
                  placeholder="DD/MM/YYYY"
                  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                  locale="id"
                  :state="report.periodTo.isValid"
                ></b-form-datepicker>
                <b-form-timepicker
                  v-model="report.periodTo.timeValue"
                  now-button
                  locale="id"
                ></b-form-timepicker>
              </b-input-group>
            </b-form-group>
          </CCol>
        </CRow>

        <CRow class="mb-2" alignHorizontal="between">
          <CCol sm="3">
            <b-form-group
              label="Plate Number"
              label-for="plate-number"
            >
              <b-form-input
                v-model="plate"
                id="plate-number"
                :disabled="true"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              label="Vehicle Type"
              label-for="vehicle-type"
            >
              <b-form-input
                v-model="type"
                id="vehicle-type"
                :disabled="true"
              ></b-form-input>
            </b-form-group>
          </CCol>
          <CCol sm="4">
            <b-input-group class="mt-3">
              <b-form-input v-model="searchValue" placeholder="Search vehicle plate"></b-form-input>
              <b-input-group-append>
                <b-button variant="primary" @click="trackVehicle"><CIcon name="cil-magnifying-glass" /></b-button>
              </b-input-group-append>
            </b-input-group>
          </CCol>
        </CRow>

        <CRow class="mt-4">
          <CCol>
            <h5><strong>Timeline</strong></h5>
          </CCol>
        </CRow>


        <CRow v-for="entry in entries">
          <CCol sm="8">
            <div class="timeline">
              <div class="entry">
                <div class="title">
                  <h3>{{ entry.entryInDate }}</h3>
                  <p>{{ entry.entryInTime }}</p>
                </div>
                <div class="body">
                  <p>{{ entry.entryInCam }}</p>
                </div>
              </div>
              <div class="entry-out">
                <div class="title">
                  <h3>{{ entry.entryOutDate }}</h3>
                  <p>{{ entry.entryOutTime }}</p>
                </div>
                <div class="body">
                  <p>{{ entry.entryOutCam }}</p>
                </div>
              </div>
            </div>
          </CCol>
          <CCol class="mb-4" sm="4">
            <CRow>
              <CCol>
                <b-img thumbnail :src="entry.entryInPlateImage" alt="Image 1"></b-img>
              </CCol>
              <CCol>
                <b-img thumbnail :src="entry.entryInVehicleImage" alt="Image 2"></b-img>
              </CCol>
            </CRow>
            <CRow>
              <CCol>
                <b-img thumbnail :src="entry.entryOutPlateImage" alt="Image 1"></b-img>
              </CCol>
              <CCol>
                <b-img thumbnail :src="entry.entryOutVehicleImage" alt="Image 2"></b-img>
              </CCol>
            </CRow>
          </CCol>
        </CRow>


        <!-- <CRow>
          <CCol sm="8">
            <div class="timeline">
              <div class="entry">
                <div class="title">
                  <h3>10 October 2020</h3>
                  <p>05:34</p>
                </div>
                <div class="body">
                  <p>Cam 1</p>
                </div>
              </div>
              <div class="entry-out">
                <div class="title">
                  <h3>10 October 2020</h3>
                  <p>05:35</p>
                </div>
                <div class="body">
                  <p>Cam 1</p>
                </div>
              </div>
              <div class="entry">
                <div class="title">
                  <h3>17 October 2020</h3>
                  <p>05:34</p>
                </div>
                <div class="body">
                  <p>Cam 1</p>
                </div>
              </div>
              <div class="entry-out">
                <div class="title">
                  <h3>17 October 2020</h3>
                  <p>05:35</p>
                </div>
                <div class="body">
                  <p>Cam 1</p>
                </div>
              </div>
            </div>
          </CCol>
          <CCol sm="4">
          
          </CCol>
        </CRow> -->

      </CCardBody>
    </CCard>

    <CModal
      color="primary"
      :show.sync="showErrorModal" :centered="true" :closeOnBackdrop="false">
      <div slot="header"><h5>{{errorTitle}}</h5></div>
      <div class="body">
        {{errorLabel}}
      </div>
      <div slot="footer">
        <CButton v-if="errorLogout" color="primary" @click="$router.push({name: 'Login'})">Login</CButton>
        <CButton v-else color="primary" @click="showErrorModal = false">OK</CButton>
      </div>
    </CModal>

  </CContainer>
</template>

<script>
import moment from 'moment'
require('@/assets/timeline.scss')

export default {
  name: 'VehicleTracker',
  props: ['plate_number'],
  data() {
    const today = this.$moment().format('YYYY-MM-DD')
    return {
      collapse: false,

      isLoading: false,

      searchValue: "",

      disableVehicleType: false,
      disableFirstTrackTime: false,
      disableLastTrackTime: false,

      isSearching: false,
      
      selected: [],
      options: [
        { item: 'car', name: 'Car' },
        { item: 'truck', name: 'Truck' },
        { item: 'bus', name: 'Bus' },
        { item: 'motorcycle', name: 'Motorcycle' }
      ],
      camera: [],

      plate: "",
      type: "",

      report: {
        periodFrom: {
          value: this.$moment().subtract(1, 'months').format('YYYY-MM-DD'),
          timeValue: '00:00:00',
          isValid: null,
          isDisabled: false,
          isRequired: true,
          minValue: '',
          maxValue: today,
          payloadKey: "periodFrom"
        },
        periodTo: {
          value: today,
          timeValue: '23:59:00',
          isValid: null,
          isDisabled: false,
          isRequired: true,
          minValue: '',
          maxValue: today,
          payloadKey: "periodTo"
        },
      },

      entries: [
        // {
        //   entryInDate: "10 October 2020",
        //   entryInTime: "05:35",
        //   entryInCam: "Cam 1",
        //   entryOutDate: "10 October 2020",
        //   entryOutTime: "05:36",
        //   entryOutCam: "Cam 1",
        //   entryInPlateImage: null,
        //   entryInVehicleImage: null,
        //   entryOutPlateImage: null,
        //   entryOutVehicleImage: null
        // },
        // {
        //   entryInDate: "17 October 2020",
        //   entryInTime: "05:35",
        //   entryInCam: "Cam 1",
        //   entryOutDate: "17 October 2020",
        //   entryOutTime: "05:36",
        //   entryOutCam: "Cam 1",
        //   entryInPlateImage: null,
        //   entryInVehicleImage: null,
        //   entryOutPlateImage: null,
        //   entryOutVehicleImage: null
        // },
      ],

      showErrorModal: false,
      errorLogout: false,
      errorLabel: 'Unexpected Error',
      errorTitle: 'Error!',
      tablePageOptions: [
        { value: 10, text: '10'},
        { value: 20, text: '20'},
        { value: 30, text: '30'},
        { value: 40, text: '40'},
        { value: 50, text: '50'}
      ],
      table: {
        totalViewText: '',
        isLoaded: true,
        fields: [
          {key: "index", label: "No.", sortable: false},
          {key: "plate", label: "Plate Number", sortable: true},
          {key: "type", label: "Type", sortable: true},
          {key: "first_tracked_time", label: "First Tracked Time", sortable: true },
          {key: "last_tracked_time", label: "Last Tracked Time", sortable: true },
          {key: "actions", label: "Actions", sortable: false, class:"custom-column-action-user"},
        ],

        items: [
          {
            plate: "B 1234 AB",
            type: "Car",
            first_tracked_time: "10 Oct 2022 05:25",
            last_tracked_time: "10 Oct 2022 05:26"
          }
        ],
        sort: {
          by: null,
          desc: false
        },

        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        totalPages: 0
      },
    }
  },
  methods: {

    getProps() {
      if (this.plate_number) this.searchValue = this.plate_number
    },

    trackVehicle() {
      this.isSearching = true
      this.isLoading = true
      
      // URL builder
      let postUrl = "/vehicle_tracker_log"
      let obj = {
        first_tracked_time: this.report.periodFrom.value + ' ' + this.$helper.showData(this.report.periodFrom.timeValue, "shortTime"),
        last_tracked_time: this.report.periodTo.value + ' ' + this.$helper.showData(this.report.periodTo.timeValue, "shortTime"),
        search_value: this.searchValue
      }

      return this.$axios.post(postUrl, obj).then(response => {
        if(response.status == 200){
          let data = response.data.data

          this.plate = data[0].plate_number
          this.type = data[0].vehicle_type.charAt(0).toUpperCase() + data[0].vehicle_type.slice(1)

          for(var x = 0; x < data.length; x++) {
            let camera = null
            
            for (var x = 0; x < this.camera.length; x++) {
              if (this.camera[x].value == data[x].camera_id) {
                camera = this.camera[x].text
                break;
              }
            }

            this.entries[x] = {
              entryInDate: this.$helper.showData(data[x].start_detected, "longDate"),
              entryInTime: this.$helper.showData(data[x].start_detected, "longTimeFromLongDate"),
              entryInCam: camera,
              entryOutDate: this.$helper.showData(data[x].end_detected, "longDate"),
              entryOutTime: this.$helper.showData(data[x].end_detected, "longTimeFromLongDate"),
              entryOutCam: camera,
              entryInPlateImage: data[x].plate_image_in,
              entryInVehicleImage: data[x].vehicle_image_in,
              entryOutPlateImage: data[x].plate_image_out,
              entryOutVehicleImage: data[x].vehicle_image_out
            }
          }
        }
        else{
          this.$helper.toastError(this, "Pengambilan Tracker Gagal! " + (response.data.message ? response.data.message : "Unknown Error"))
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Pengambilan Tracker Gagal! " +  (!this.$helper.isEmpty(error.response.data.message) ? error.response.data.message : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Pengambilan Tracker Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.isSearching = false
        this.isLoading = false
      })
    },

    getCameras() {
      // URL builder
      let getUrl = "/cameras"

      return this.$axios.get(getUrl).then(response => {
        if(response.status == 200){
          let data = response.data.data
          for (var x = 0; x < data.length; x++) {
            this.camera.push({
              value: data[x].id, 
              text: data[x].name
            })
          }
        }
        else{
          this.$helper.toastError(this, "Load Camera Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Load Camera Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Load Camera Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
    },

  },

  created() {
    this.getProps()
    this.getCameras()
  }
}
</script>

<style>

</style>
